// src/services/adminSupervision.js
// GET /admin/supervision — données poussées par les Workers (OPAQUE)
// ≠ GET /admin/supervision/indicateurs (relais Paiement)

import { apiFetch } from './adminHttp';

/**
 * GET /admin/supervision
 * Permission SUPERVISION_VOIR.
 * Schéma opaque : retourner tel quel sans interprétation métier.
 */
export async function getSupervision() {
  return apiFetch('/admin/supervision', {
    method: 'GET',
  });
}
